import { render } from "./Card2.vue?vue&type=template&id=54c76d5c"
import script from "./Card2.vue?vue&type=script&lang=js"
export * from "./Card2.vue?vue&type=script&lang=js"

import "./Card2.vue?vue&type=style&index=0&id=54c76d5c&lang=css"

import exportComponent from "C:\\4 Websites\\enfinity\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__